// Load polyfills first
import '@shared/utils/src/polyfills'
import '@shared/utils/src/staleChunkReload'
// Import fonts
import './assets/fonts/source-sans.css'

import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'

import { LicenseInfo, muiXTelemetrySettings } from '@mui/x-license'

import HoneybadgerProvider from '@shared/providers/src/HoneybadgerProvider'

import '@shared/utils/src/dayjsImports'

import router from './pages/Router'

muiXTelemetrySettings.disableTelemetry()
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_PRO_LICENSE)

ReactDOM.createRoot(document.getElementById('root')).render(
  <HoneybadgerProvider>
    <RouterProvider router={router} />
  </HoneybadgerProvider>
)
